import { Instance, SnapshotIn, SnapshotOut, types } from 'mobx-state-tree';
import { UserImageModelInstance } from './userImage';
import { BaseModel } from './_base/baseModel';

export type TUserTextModel = typeof UserTextModel;
export type UserTextModelInstance = Instance<TUserTextModel>;
export interface IUserTextModelIn extends SnapshotIn<TUserTextModel> {}
export interface IUserTextModelOut extends SnapshotOut<TUserTextModel> {}
export interface IUserTextModel extends UserImageModelInstance {}

export const UserTextModel = BaseModel.named('UserText').props({
  id: types.string,
  productId: types.string,
  userTextAreaId: types.string,

  text: types.string,
  font: types.string,
  color: types.string,
  style: types.string,

  size: types.number, // TODO: decidere valore di default

  anchor: types.string,
});